export const getAcronym = (str: string): string =>
	str
		.split(/\s/)
		.reduce((response, word) => (response += word.slice(0, 1)), '')
		.toLocaleUpperCase()
		.slice(0, 2)
